export const ImageSize = {
  Default: 96,
};

export default {
  ImageSize,
};
